export enum ChatActions {
  getChatNotification = "__CHAT_ACTIONS/getChatNotification",
  getChatRooms = "__CHAT_ACTIONS/getChatRooms",
  getChatRoomMessages = "__CHAT_ACTIONS/getChatRoomMessages",
  loadMoreRoomMessages = "__CHAT_ACTIONS/loadMoreRoomMessages",
  markRoomAsSeen = "__CHAT_ACTIONS/markRoomAsSeen",
  syncChatRooms = "__CHAT_ACTIONS/syncChatRooms",
  roomMessagesSync = "__CHAT_ACTIONS/roomMessagesSync",
}
